// admin/adminApi.js – Zugriff auf die /admin-Endpunkte.
// Nutzt denselben Client wie der Rest der App; der Interceptor haengt das
// Token an. Serverseitig entscheidet adminAuth ueber das isAdmin-Flag.
import api from '../api';

const adminApi = {
  overview: () => api.get('/admin/overview').then((r) => r.data),
  risks: () => api.get('/admin/risks').then((r) => r.data),
  users: () => api.get('/admin/users').then((r) => r.data),
  user: (id) => api.get(`/admin/users/${id}`).then((r) => r.data),
  updateUser: (id, patch) => api.patch(`/admin/users/${id}`, patch).then((r) => r.data),
  setActive: (id, aktiv) => api.post(`/admin/users/${id}/pause`, { aktiv }).then((r) => r.data),
  archiveUser: (id) => api.delete(`/admin/users/${id}`).then((r) => r.data),
  funnel: () => api.get('/admin/funnel').then((r) => r.data),
  payments: () => api.get('/admin/payments').then((r) => r.data),
  syncPayment: (id) => api.post(`/admin/payments/${id}/sync`).then((r) => r.data),
  jobRuns: () => api.get('/admin/job-runs').then((r) => r.data),
  templates: () => api.get('/admin/whatsapp-templates').then((r) => r.data),
  konfigHealth: () => api.get('/admin/health/config').then((r) => r.data),
  triggerDaily: (force) => api.post('/admin/trigger-daily-checkin', { force }).then((r) => r.data),
  triggerEmergency: (force) => api.post('/admin/trigger-emergency-check', { force }).then((r) => r.data),
};

export default adminApi;
